import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { CursoService } from '../../services/curso/curso.service';
import { Curso } from '../../models/curso/curso.model';
import { TiposService } from '../../services/tipos/tipos.service';
import { Tipos } from '../../models/tipos/tipos.model';
import { RankingBecasService } from '../../services/ranking-becas/ranking-becas.service';

import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductosService } from '../../services/productos/productos.service';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-ranking-becas',
  templateUrl: '../../pages/ranking-becas/ranking-becas.component.html',
  styleUrls: ['../../pages/ranking-becas/ranking-becas.component.css']
})
export class RankingBecasComponent implements OnInit 
{ 
    rol: string = localStorage.getItem("rol")
    cursosExcelencia: Curso[]
    cursosNecesidades: Curso[]
    presupuestoTotal: any
    editaCupos: boolean = false;
    rankingAprobado: boolean = false

    constructor(public router: Router, private cursoService: CursoService, private productosService:ProductosService, 
                private tiposService: TiposService, private rankingService: RankingBecasService,
                private dialog: MatDialog, private snackBar: MatSnackBar, ) { }

    ngOnInit(): void 
    {
        console.log(this.rol)

        this.loadData()     
    }

    loadData()
    {
        let vm = this

        this.rankingService.rankingAprobado().then ( () => vm.rankingAprobado = true )
        .catch( error => console.log(error) )
        
        this.productosService.obtieneProductos().then
        (
            productos => 
            { 
                productos[0].parametros.forEach(parametro => 
                {
                    if(parametro.descripcion == 'PRESUPUESTO') { vm.presupuestoTotal = parametro.valor }                    
                })
            }
        )
        .catch( error => console.log(error) )

        this.tiposService.traeTipos(1).then
        (
            (tipos: Tipos[]) =>
            {
                tipos.forEach
                (
                    tipo =>
                    {
                        vm.cursoService.traeCursos(tipo.id).then
                        (
                            (cursos: Curso[]) =>
                            {           
                                if(tipo.descripcion.includes("EXCELENCIA"))
                                {    
                                    cursos.forEach(
                                        curso =>
                                        {
                                            vm.rankingService.obtienePostulacionesAprobadas(curso.idTipo, curso.id).then
                                            (
                                                cantidad => curso["postulaciones"] = cantidad
                                            )                                         
                                        }
                                    )
                                    
                                    vm.cursosExcelencia = cursos
                                }
                                else
                                {
                                    cursos.forEach(
                                        curso =>
                                        {
                                            vm.rankingService.obtienePostulacionesAprobadas(curso.idTipo, curso.id).then
                                            (
                                                cantidad => curso["postulaciones"] = cantidad
                                            )                                        
                                        }
                                    )

                                    vm.cursosNecesidades = cursos
                                }                                
                            }
                        )
                        .catch( error => console.log(error))
                    }
                );
            }
        )
        .catch( error => console.log(error) )
    }

    modificarCupos()
    {
        let cursosModificar: any = []
        let vm = this

        this.cursosExcelencia.forEach(
            curso => { cursosModificar.push( { id:curso.id, cupoTotal:curso.cupoTotal } ) }
        )
        
        this.cursosNecesidades.forEach(
            curso => { cursosModificar.push( { id:curso.id, cupoTotal:curso.cupoTotal } ) }
        )

        this.editaCupos = false
        console.log(cursosModificar)
        
        this.cursoService.editaCuposCursos(cursosModificar).then
        (
            () => vm.openAlertDialog('Se han actualizado exitosamente los cupos por curso.', 'btn-success')
        )
        .catch ( error => console.log(error) )
    }

    openDialog() 
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de Aprobar las Solicitudes?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => 
        {
            if (confirmed) 
            {
                var presupuesto = 0
                var vm = this

                this.cursosExcelencia.forEach( curso => presupuesto += curso.cupoTotal * curso.monto )
                
                this.cursosNecesidades.forEach( curso => presupuesto += curso.cupoTotal * curso.monto )
                
                if(presupuesto > this.presupuestoTotal)
                {
                    this.openAlertDialog('El presupuesto a entregar supera el establecido en los parámetros. Favor revisar.', 'btn-dark')
                    return false
                }
                else
                {
                    this.rankingService.apruebaParaPago().then
                    (
                        () => 
                        {
                            vm.openAlertDialog('El ranking se ha aprobado exitosamente.', 'btn-success')

                            vm.rankingAprobado = true
                        }                        
                    )
                    .catch( error => 
                    {
                        console.log(error)

                        vm.openAlertDialog('Ha ocurrido un error para aprobar el ranking.', 'btn-danger')
                    })
                }
            }
        })
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    descargaCsv()
    {
        this.rankingService.listadoPreAprobacion().then
        (
            (postulaciones: any) =>
            {
                let str = '"CORRELATIVO";"ID POSTULACION";"REGION";"RUT";"NOMBRE AFILIADO";"NOMBRE CARGA";"CALIFICACION";'
                str += '"DIAGNOSTICO";"TIPO BECA";"ETAPA ESCOLAR";"FECHA CREACION";"USUARIO VALIDADOR"\r\n';  
		
                postulaciones.forEach( (element: any, i: number) => 
                {
                    let line = ''
                    
                    line += '"' + (i + 1) + '"' + ';'
                    line += '"' + element.idPostulacion + '"' + ';'
                    line += '"' + element.region + '"' + ';'
                    line += '"' + element.rut + '"' + ';'
                    line += '"' + element.nombreAfiliado + '"' + ';'
                    line += '"' + (element.nombreCarga ? element.nombreCarga : 'N/A') + '"' + ';'
                    line += '"' + (element.calificacion ? element.calificacion : '') + '"' + ';'
                    line += '"' + (element.diagnostico ? element.diagnostico : '') + '"' + ';'
                    line += '"' + element.tipoBeca + '"' + ';'
                    line += '"' + element.etapaEscolar + '"' + ';'
                    line += '"' + element.fechaCreacion + '"' + ';'
                    line += '"' + element.usuarioValidador + '"' + ';'

                    str += line + '\r\n'
                })
                
                let a: any = document.createElement('a')
                a.setAttribute('style', 'display:none;')
                document.body.appendChild(a)
                
                const blob = new Blob([ str ], { type: 'text/csv' })
                const url = window.URL.createObjectURL(blob)
                
                a.href = url

                a.download = 'PreAprobacionRanking.csv'
                
                a.click()   
            }
        ) 
        .catch( error => console.log(error) ) 
    }

    descargaCsvResultado()
    {
        this.rankingService.listadoResultado().then
        (
            (postulaciones: any) =>
            {
                let str = '"CORRELATIVO";"ID POSTULACION";"REGION";"RUT";"NOMBRE AFILIADO";"NOMBRE CARGA";'
                str += '"CALIFICACION";"TIPO BECA";"ETAPA ESCOLAR"\r\n';  
                console.log(postulaciones) 
                postulaciones.forEach( (element: any, i: number) => 
                {
                    let line = '';
                    
                    line += '"' + (i + 1) + '"' + ';'
                    line += '"' + element.idPostulacion + '"' + ';'
                    line += '"' + element.region + '"' + ';'
                    line += '"' + element.rut + '"' + ';'
                    line += '"' + element.nombreAfiliado + '"' + ';'
                    line += '"' + (element.nombreCarga ? element.nombreCarga : 'N/A') + '"' + ';'
                    line += '"' + element.calificacion + '"' + ';'
                    line += '"' + element.tipoBeca + '"' + ';'
                    line += '"' + element.etapaEscolar + '"' + ';'

                    str += line + '\r\n';
                })
                
                let a: any = document.createElement('a')
                a.setAttribute('style', 'display:none;')
                document.body.appendChild(a)
                
                const blob = new Blob([ str ], { type: 'text/csv' })
                const url = window.URL.createObjectURL(blob)
                
                a.href = url;

                a.download = 'ResultadoRanking.csv'
                
                a.click()        
            }
        ) 
        .catch( error => console.log(error) ) 
    }
}